export default __webpack_public_path__ + "static/media/Animals_18.d017df71.png";